export class Report {
  constructor({ date, url }) {
    this.date = date;
    this.url = url;
  }

  static fromJson(json) {
    return new Report({
      date: json.date,
      url: json.url,
    });
  }

  toString() {
    return `Report(date: ${this.date}, url: ${this.url})`;
  }
}

export class Reports {
  constructor({ reports }) {
    this.reports = reports.map((report) => Report.fromJson(report));
  }

  static fromJson(json) {
    return new Reports({
      reports: json.reports || [],
    });
  }

  toString() {
    return `Reports(reports: ${this.reports})`;
  }
}
